//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  WritableSignal,
  signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { CurrentUserModel } from '@core/data/models';

import { UserAvatarUpdatedMessage } from './user-avatar-updated.message';

@PresenterType({ model: UserAvatarUpdatedMessage })
@Component({
  selector: 'user-avatar-updated-message-template',
  templateUrl: './user-avatar-updated-message-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserAvatarUpdatedMessageTemplateComponent {
  public data: WritableSignal<UserAvatarUpdatedMessage> = signal<UserAvatarUpdatedMessage>(null);
  public CurrentUserModel: typeof CurrentUserModel = CurrentUserModel;

  public handleImageError(event: Event): void {
    (event.target as HTMLImageElement).src = this.CurrentUserModel.placeholderAvatarUrl;
  }
}